import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step5 } from '../../../../../shared/models/component-messages/simp_in/step5';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Initial } from '../../models/Initial';

@Component({
	selector: 'app-step5',
	templateUrl: './step5.component.html'
})
export class Step5Component implements OnInit {
	@Input() fnSimpleInitial: Initial;
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;
	public step5 = new Step5();

	constructor(public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService) {}

	public ngOnInit() {}

	public getUid() {
		return this.uid;
	}
}
